import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { buildApiErrors } from "../../helpers/common";
import httpClient from "../../provider/httpClient";

const ExpenseCategoryForm = () => {
  const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState(null);
  const navigate = useNavigate();

  const formID = searchParams.get("form_id");
  useEffect(() => {
    if (formID > 0) {
      fetchData(formID);
    }
  }, [formID]);

  const fetchData = async (formID) => {
    const response = await httpClient.get(
      `/expense-category/${formID}`
    );
    setFormData(response.data.data);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const latestFormData = {
      category_name: e.target.inputName.value,
      category_description: e.target.inputDesc.value
    }
    if (formData) {
      update(latestFormData);
    } else {
      add(latestFormData);
    }
    setFormData(null);
  };

  // Create a new user
  const add = async (userData) => {
    try {
      const response = await httpClient.post('/expense-category', userData);
      const data = await response.data;
      console.log(data);
      toast(data.message);
      if (data.status) {
        navigate('/dashboard/expense-categories');
      }
    } catch (error) {
      console.error('Error adding user:', error);
      toast.error(buildApiErrors(error));
    }
  };

  // Update an existing user
  const update = async (userData) => {
    try {
      const response = await httpClient.put(`/expense-category/${formData.id}`, userData);
      const data = await response.data;
      console.log(data);
      setFormData(data.data);
    } catch (error) {
      console.error('Error updating user:', error);
    }
  };

  return (
    <>
      <Link to='/dashboard/expense-categories' className="btn btn-primary" >Back</Link>
      <hr />
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">Expense Category Form</h6>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="inputName">Name</label>
                <input type="text" className="form-control" defaultValue={formData ? formData.category_name : ''} name="inputName" placeholder="Name" required />
              </div>
              <div className="form-group col-md-6">
                <label htmlFor="inputAddr">Description</label>
                <textarea className="form-control" defaultValue={formData ? formData.category_description : ''} name="inputDesc" required></textarea>
              </div>
            </div>
            <button type="submit" className="btn btn-primary">{formData ? ('Update') : ('Submit')}</button>
          </form>
        </div>
      </div>
    </>
  )
}

export default ExpenseCategoryForm;